import { PlotDataEx } from "../interfaces";

export const configPieChartData = (
  data: { values: Array<number>; labels: Array<string> },
  selectedColorPalette: Array<string>
) => {
  return [createPlotData(data, selectedColorPalette)];
};

const createPlotData = (
  d: { values: Array<number>; labels: Array<string> },
  selectedColorPalette: Array<string>
): PlotDataEx => {
  return {
    labels: d?.labels,
    values: d?.values,
    type: "pie",
    showlegend: true,
    // hovertemplate: `<b>%{y:.3f}</b> at %{x} <br>${d.title}<extra></extra>`,
    // hoverinfo: 'label+percent',
    textinfo: "value+percent",
    textposition: "inside",
    marker: {
      colors: selectedColorPalette,
    },
    hole: 0.4,
  } as PlotDataEx;
};
